var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workerorderindex"
  }, [_c('top'), _vm._v(" "), _c('div', {
    staticClass: "nav"
  }, [_c('router-link', {
    staticStyle: {
      "color": "rgb(31, 55, 61)"
    },
    attrs: {
      "to": {
        path: _vm.indexUrl
      }
    }
  }, [_c('span', [_vm._v("首页")])]), _vm._v(" "), _vm._l((_vm.questionclass), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "navbread"
    }, [_vm._v(_vm._s('>' + item))])
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btna color",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "to": {
        path: '/myorder'
      }
    }
  }, [_vm._v("我的工单")])], 2), _vm._v(" "), _vm._l((_vm.showdata), function(item, index1) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.contentis),
        expression: "contentis"
      }],
      key: index1,
      staticClass: "content"
    }, [(item.typeId == 12) ? _c('div', [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-select', {
      staticClass: "wid",
      on: {
        "visible-change": function($event) {
          _vm.changedata(item, _vm.gamearea[item.id])
        },
        "change": function($event) {
          _vm.datacommit(_vm.gamevalue[item.id], item)
        }
      },
      model: {
        value: (_vm.gamevalue[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.gamevalue, item.id, $$v)
        },
        expression: "gamevalue[item.id]"
      }
    }, _vm._l((_vm.gamearea[item.id]), function(item, i) {
      return _c('el-option', {
        key: i,
        attrs: {
          "label": item.label,
          "value": item.value
        }
      })
    }))], 1) : (item.typeId == 1) ? _c('div', {
      staticClass: "dns"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-input', {
      staticClass: "wid",
      attrs: {
        "placeholder": item.defaultContent
      },
      on: {
        "blur": function($event) {
          _vm.datacommit(_vm.dns[item.id], item)
        }
      },
      model: {
        value: (_vm.dns[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.dns, item.id, $$v)
        },
        expression: "dns[item.id]"
      }
    })], 1) : (item.typeId == 5) ? _c('div', {
      staticClass: "dns"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-input', {
      staticClass: "wid",
      attrs: {
        "placeholder": item.defaultContent
      },
      on: {
        "blur": function($event) {
          _vm.datacommit(_vm.phonenumver[item.id], item)
        }
      },
      model: {
        value: (_vm.phonenumver[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.phonenumver, item.id, $$v)
        },
        expression: "phonenumver[item.id]"
      }
    })], 1) : (item.typeId == 6) ? _c('div', {
      staticClass: "dns"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-input', {
      staticClass: "wid",
      attrs: {
        "placeholder": item.defaultContent
      },
      on: {
        "blur": function($event) {
          _vm.datacommit(_vm.number[item.id], item)
        }
      },
      model: {
        value: (_vm.number[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.number, item.id, $$v)
        },
        expression: "number[item.id]"
      }
    })], 1) : (item.typeId == 7) ? _c('div', {
      staticClass: "dns"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-input', {
      staticClass: "wid",
      attrs: {
        "placeholder": item.defaultContent
      },
      on: {
        "blur": function($event) {
          _vm.datacommit(_vm.idcard[item.id], item)
        }
      },
      model: {
        value: (_vm.idcard[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.idcard, item.id, $$v)
        },
        expression: "idcard[item.id]"
      }
    })], 1) : (item.typeId == 8) ? _c('div', {
      staticClass: "dns"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-input', {
      staticClass: "wid",
      attrs: {
        "placeholder": item.defaultContent
      },
      on: {
        "blur": function($event) {
          _vm.datacommit(_vm.email[item.id], item)
        }
      },
      model: {
        value: (_vm.email[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.email, item.id, $$v)
        },
        expression: "email[item.id]"
      }
    })], 1) : (item.typeId == 2) ? _c('div', {
      staticClass: "explain"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-input', {
      staticClass: "wid",
      attrs: {
        "type": "textarea",
        "rows": 4,
        "placeholder": item.defaultContent
      },
      on: {
        "blur": function($event) {
          _vm.datacommit(_vm.explain[item.id], item)
        }
      },
      model: {
        value: (_vm.explain[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.explain, item.id, $$v)
        },
        expression: "explain[item.id]"
      }
    })], 1) : (item.typeId == 13) ? _c('div', {
      staticClass: "sex"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-radio-group', {
      staticClass: "radio",
      on: {
        "change": function($event) {
          _vm.datacommit(_vm.sex[item.id], item)
        }
      },
      model: {
        value: (_vm.sex[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.sex, item.id, $$v)
        },
        expression: "sex[item.id]"
      }
    }, _vm._l((_vm.sexlabel[item.id]), function(ele, index2) {
      return _c('el-radio', {
        key: index2,
        attrs: {
          "label": ele.value
        }
      }, [_vm._v(_vm._s(ele.value))])
    }))], 1) : (item.typeId == 9) ? _c('div', {
      staticClass: "picture"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('p', {
      staticClass: "pictureclass",
      staticStyle: {
        "width": "300px",
        "float": "left"
      }
    }, [_vm._v("为了帮助您更好的解决问题,请上传相关描述的图片。每张不超过9M，支持jpg、png、bmp、gif")]), _vm._v(" "), _c('el-upload', {
      staticClass: "upload-demo wid",
      attrs: {
        "action": _vm.action,
        "on-success": _vm.handlePreview,
        "on-remove": _vm.handleRemove,
        "before-upload": _vm.beforeload,
        "file-list": _vm.fileList2[item.name],
        "list-type": "picture",
        "withCredentials": true
      }
    }, [(_vm.picid[item.id] == true) ? _c('el-button', {
      staticClass: "color",
      staticStyle: {
        "margin-top": "10px"
      },
      style: ({
        backgroundColor: _vm.boxBodyColor
      }),
      attrs: {
        "id": item.spanid + 'a',
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.datacommit(_vm.fileList2[item.name], item)
        }
      }
    }, [_vm._v(" 添加文件 ")]) : _vm._e()], 1)], 1) : (item.typeId == 14) ? _c('div', {
      staticClass: "city"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('el-checkbox-group', {
      staticClass: "cityclass",
      on: {
        "change": function($event) {
          _vm.datacommit(_vm.checkedCities1[item.id], item)
        }
      },
      model: {
        value: (_vm.checkedCities1[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.checkedCities1, item.id, $$v)
        },
        expression: "checkedCities1[item.id]"
      }
    }, _vm._l((_vm.cities[item.id]), function(city, j) {
      return _c('el-checkbox', {
        key: j,
        attrs: {
          "label": city
        }
      }, [_vm._v(_vm._s(city))])
    }))], 1) : (item.typeId == 15) ? _c('div', {
      staticClass: "picture"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('p', {
      staticClass: "pictureclass",
      staticStyle: {
        "width": "300px",
        "float": "left"
      }
    }, [_vm._v("为了帮助您更好的解决问题,请上传相关描述的视频。视频大小不超过500M")]), _vm._v(" "), _c('el-upload', {
      staticClass: "upload-demo wid",
      attrs: {
        "action": _vm.action,
        "on-success": _vm.handleVideoPreview,
        "on-remove": _vm.handleVideoRemove,
        "before-upload": _vm.videoBeforeload,
        "file-list": _vm.fileVideoList[item.id],
        "list-type": "picture",
        "accept": "video/*",
        "withCredentials": true
      }
    }, [(_vm.picid[item.id] == true) ? _c('el-button', {
      staticClass: "color",
      staticStyle: {
        "margin-top": "10px"
      },
      style: ({
        backgroundColor: _vm.boxBodyColor
      }),
      attrs: {
        "id": item.spanid + 'a',
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.datacommit(_vm.fileVideoList[item.id], item)
        }
      }
    }, [_vm._v(" 添加文件 ")]) : _vm._e()], 1)], 1) : (item.typeId == 16) ? _c('div', {
      staticClass: "date"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('div', {
      staticClass: "block"
    }, [_c('el-date-picker', {
      staticClass: "time",
      attrs: {
        "type": "datetime",
        "placeholder": item.defaultContent || '选择日期时间'
      },
      on: {
        "change": function($event) {
          _vm.datacommit(_vm.datetimes[item.id], item)
        }
      },
      model: {
        value: (_vm.datetimes[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.datetimes, item.id, $$v)
        },
        expression: "datetimes[item.id]"
      }
    })], 1)]) : (item.typeId == 3) ? _c('div', {
      staticClass: "date"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('div', {
      staticClass: "block"
    }, [_c('el-date-picker', {
      staticClass: "time",
      attrs: {
        "type": "date",
        "picker-options": _vm.pickerOptions0,
        "placeholder": item.defaultContent
      },
      on: {
        "change": function($event) {
          _vm.datacommit(_vm.datetime[item.id], item)
        }
      },
      model: {
        value: (_vm.datetime[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.datetime, item.id, $$v)
        },
        expression: "datetime[item.id]"
      }
    })], 1)]) : (item.typeId == 4) ? _c('div', {
      staticClass: "date"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name + ':'))]), _vm._v(" "), _c('div', {
      staticClass: "block"
    }, [_c('el-time-picker', {
      staticClass: "time",
      attrs: {
        "type": "date",
        "format": "HH:mm",
        "placeholder": item.defaultContent
      },
      on: {
        "change": function($event) {
          _vm.datacommit(_vm.hourtime[item.id], item)
        }
      },
      model: {
        value: (_vm.hourtime[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.hourtime, item.id, $$v)
        },
        expression: "hourtime[item.id]"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), ((item.required == true && (item.typeId == 12 || item.typeId == 13 || item.typeId == 14) && item.defaultContent == '') || (item.required == true && !(item.typeId == 12 || item.typeId == 13 || item.typeId == 14))) ? _c('span', {
      staticClass: "error1",
      attrs: {
        "id": item.spanid
      }
    }, [_vm._v("*必填项")]) : _c('span', {
      staticClass: "error1",
      attrs: {
        "id": item.spanid
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "clear": "both"
      }
    })])
  }), _vm._v(" "), (_vm.contentis == true && _vm.btnclass == 1) ? _c('div', {
    staticClass: "btn"
  }, [_c('el-button', {
    staticClass: "color",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.commit
    }
  }, [_vm._v("提交")])], 1) : (_vm.contentis == true && _vm.btnclass == 2) ? _c('div', {
    staticClass: "btn"
  }, [_c('el-button', {
    staticClass: "color",
    staticStyle: {
      "background": "#ccc"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("提交")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.downloadis),
      expression: "downloadis"
    }],
    staticClass: "download"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/workorder/download.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("正在提交...")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.successis),
      expression: "successis"
    }],
    staticClass: "success"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/workorder/success.png")
    }
  }), _vm._v(" "), _c('h4', [_vm._v("提交成功,感谢您的反馈！")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.jishi + '秒之后返回首页'))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.erroris),
      expression: "erroris"
    }],
    staticClass: "success"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/workorder/error.png")
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "error"
  }, [_vm._v("问题反馈失败,请稍后再试！")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.jishi + '秒之后返回首页'))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginis),
      expression: "loginis"
    }],
    staticClass: "login"
  }, [_c('p', [_vm._v("手机号为查看单据处理结果的依据")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("手机号")]), _vm._v(" "), _c('el-input', {
    staticClass: "phonenumber",
    attrs: {
      "placeholder": "请输入手机号码"
    },
    on: {
      "blur": _vm.phonego
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.phoneis))])], 1), _vm._v(" "), _c('div', {
    staticClass: "mat"
  }, [_c('span', [_vm._v("随机码")]), _vm._v(" "), _c('el-input', {
    staticClass: "verify",
    attrs: {
      "placeholder": "短信随机码"
    },
    model: {
      value: (_vm.verify),
      callback: function($$v) {
        _vm.verify = $$v
      },
      expression: "verify"
    }
  }), _vm._v(" "), (_vm.verifyis) ? _c('span', {
    staticClass: "verifybtn",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    on: {
      "click": _vm.verifygo
    }
  }, [_vm._v("获取随机码")]) : _c('span', {
    staticClass: "verifybtn",
    style: ({
      backgroundColor: _vm.boxBodyColor
    })
  }, [_vm._v(_vm._s(_vm.timesecond + "s"))]), _vm._v(".\n         "), _c('p', [_vm._v(_vm._s(_vm.veris))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "color verbtn",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.verifyconfirm
    }
  }, [_vm._v("下一步")])], 1)], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03ce5a3d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workorder/workcommit.vue
// module id = 0g43
// module chunks = 1